/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React contexts
import { useMaterialUIController } from "context";

function DataTableHeadCell({ width, children, sorted, align, ...rest }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <MDBox
      component="th"
      width={width}
      py={1.5}
      px={3}
      sx={({
        palette: { grey, white, light, dark },
        borders: { borderWidth, borderColor },
        functions: { pxToRem },
        typography,
      }) => ({
        backgroundColor: darkMode ? dark.main : grey[100], // ✅ couleur de fond en-tête selon mode
        borderBottom: `${borderWidth[1]} solid ${borderColor}`,
        fontSize: typography.size.xs,
        fontWeight: typography.fontWeightBold,
        textAlign: align,
        color: darkMode ? white.main : grey[800],
        textTransform: "uppercase",
        letterSpacing: "0.05rem",
      })}
    >
      <MDBox
        {...rest}
        display="flex"
        justifyContent={align === "right" ? "flex-end" : "flex-start"}
        alignItems="center"
        lineHeight={1}
      >
        {children}
        {sorted && (
          <Icon
            sx={{
              fontSize: "1rem",
              ml: 0.5,
              mt: 0.1,
            }}
          >
            {sorted === "asce"
              ? "arrow_upward"
              : sorted === "desc"
                ? "arrow_downward"
                : "unfold_more"}
          </Icon>
        )}
      </MDBox>
    </MDBox>
  );
}

DataTableHeadCell.defaultProps = {
  width: "auto",
  sorted: "",
  align: "left",
};

DataTableHeadCell.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node.isRequired,
  sorted: PropTypes.oneOf(["asce", "desc", "none", ""]),
  align: PropTypes.oneOf(["left", "right", "center"]),
};

export default DataTableHeadCell;
